import React, {useEffect, useState} from 'react';
import SongItem from '../../SongItem/SongItem';
import SongItemWrapper  from '../../SongItemWrapper/SongItemWrapper'
import { Container, Row , Col } from 'reactstrap';

const SongsWithoutContacts = (props) => {
    
    return (
        <Container className="songs-without-contacts">
            <Row>
                <Col xs="12" sm="12" md="12">
                    <h3>שאר השירים בפלייליסט שלי</h3>
                </Col>
            </Row>
            {props.data?.map((item, i) => (            
                <Row key={i}>
                    <Col xs="12" sm="12" md="12">
                    <div className="songs-without-contacts-item">
                        <SongItemWrapper songId={item.productId} isDefaultSong={item.isDefault} isDownloadMode={false} isPlaylistMode={true}  audio={{ id: item.productId, description: item.title, author: item.artists.artistName, image: item.image, funtonPrevUrl: item.funtonPrevUrl }}>
                                <SongItem isDisplayPlayer={true} playerSize={87} isDetailsFromLeft={true} onClickSong={()=> {}} audio={{ id: item.productId, description: item.title, author: item.artists.artistName, image: item.image, funtonPrevUrl: item.funtonPrevUrl }} ></SongItem>
                        </SongItemWrapper>
                    </div>
                    </Col>
                </Row>            
            ))}
        </Container>) ;
}

export default SongsWithoutContacts;


